import {
  SET_TITLE,
  SET_REPORT_DATA,
  SET_REPORT,
  SET_SAVING,
  SET_FEEDBACK_SAVED,
  SET_FEEDBACK_SAVING,
  SET_MODAL_OPEN,
  SET_SHARE_MODAL_OPEN,
} from './reducer';

export const setFeedbackSaving = () => (dispatch) => {
  const payload = {
    feedback: 'Saving...',
    touched: true,
  };

  dispatch({
    type: SET_FEEDBACK_SAVING,
    payload,
  });
};

export const setFeedbackSaved = () => (dispatch) => {
  const payload = {
    feedback: 'Saved.',
    touched: false,
  };

  dispatch({
    type: SET_FEEDBACK_SAVED,
    payload,
  });
};

export const setSaving = () => (dispatch) => {
  dispatch({
    type: SET_SAVING,
  });
};

export const setReport = (report) => (dispatch) => {
  const payload = {
    report,
  };
  dispatch({
    type: SET_REPORT,
    payload,
  });
};

export const setReportData = (reportData) => (dispatch) => {
  setFeedbackSaving()(dispatch);
  const payload = {
    reportData,
  };
  dispatch({
    type: SET_REPORT_DATA,
    payload,
  });
};

export const setTitle = (title) => (dispatch) => {
  setFeedbackSaving()(dispatch);
  const payload = {
    title,
  };
  dispatch({
    type: SET_TITLE,
    payload,
  });
};

export const setModalOpen = (modalOpen) => (dispatch) => {
  const payload = {
    modalOpen: !modalOpen,
  };
  dispatch({
    type: SET_MODAL_OPEN,
    payload,
  });
};

export const setShareModalOpen = (shareModalOpen) => (dispatch) => {
  const payload = {
    shareModalOpen: !shareModalOpen,
  };
  dispatch({
    type: SET_SHARE_MODAL_OPEN,
    payload,
  });
};
